import styled from "styled-components";
import dropDownArrowIcon from "assets/icons/dropDownArrowIcon.svg";
import { pxToRem } from "styles/utils";
import {
  DropdownControl,
  DropdownMenu,
  DropdownOptionItem,
} from "../DropdownPrimitives.styles";

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DropdownInput = styled(DropdownControl)``;

export const DropdownIcon = styled.span<{ $isOpen: boolean }>`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  height: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  background: url(${dropDownArrowIcon}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
  transform: translateY(-50%) rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
  transition: transform 0.2s ease-in-out;
`;

export const DropdownList = styled(DropdownMenu)`
  width: auto;
  max-height: ${pxToRem(150)};
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DropdownItem = styled(DropdownOptionItem)``;
